/**
 * HINOMEエンタープライズのデモ設定
 *
 * デモは実データを一切参照せずサンプルデータだけで動くため、
 * Firebase ユーザーや organizations / users のレコードを必要としない。
 * 環境ごとに変わる値ではないので、環境変数ではなく固定値として持つ。
 */

/** デモセッションで表示するアカウントのメールアドレス（表示専用の識別子） */
export const CORPORATE_DEMO_EMAIL = "hinome-enterprise@test";

/**
 * デモ中であることを保持するキー
 * ページ遷移・リロードでデモが切れないよう sessionStorage に持つ（タブを閉じれば消える）
 */
export const CORPORATE_DEMO_STORAGE_KEY = "hinome_corporate_demo";

/** デモ中かどうか。SSR では常に false */
export const isCorporateDemoSession = (): boolean => {
  if (typeof window === "undefined") return false;
  try {
    return window.sessionStorage.getItem(CORPORATE_DEMO_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};

export const startCorporateDemoSession = (): void => {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(CORPORATE_DEMO_STORAGE_KEY, "1");
  } catch {
    // プライベートブラウジング等で書けない場合は同一ページ内のみのデモになる
  }
};

export const endCorporateDemoSession = (): void => {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(CORPORATE_DEMO_STORAGE_KEY);
  } catch {
    // 無視してよい
  }
};
